<template>
<!-- START log in test -->
  <h5 class="title is-5 has-text-centered">Please login to view energy report</h5>
  <div class="columns is-centered">
    <div class="column is-one-third">
      <div class="field">
        <label class="label">Username</label>
        <div class="control">
          <input id="username" class="input is-dark is-medium" type="text" v-model="this.username" />
        </div>
      </div>
      <div class="field">
        <label class="label">Password</label>
        <div class="control">
          <input class="input is-dark is-medium" type="password" v-model="this.password" />
        </div>
      </div>
        <button class="button is-medium has-text-white cc-has-background-blue" v-on:click="this.authenticateUser()">Login</button>
    </div>
  </div>
  <div class="columns is-centered">
    <div class="column is-one-third">
      <ccError ref="ccError"></ccError>
    </div>
  </div>
  <!-- END Log in test -->
  <div class="notification has-background-light has-text-centered">
    <p>By logging in you consent to Climacheck Online using necessary cookies to improve your usage of our services.</p>
  </div>
</template>
<script>
import { System } from '@/classes/System'
import ccHelpers from '@/components/ccHelpers'

export default {
  data: function () {
    return {
      username: null,
      password: null
    }
  },
  computed: {
    system: function () {
      if (this.$store.state.system) {
        return this.$store.state.system
      } else {
        return null
      }
    }
  },
  mounted () {
    localStorage.setItem('ccUsername', '')
    localStorage.setItem('ccPassword', '')
    localStorage.setItem('ccSystem', '')
    localStorage.setItem('ccAuthenticated', false)
  },
  methods: {
    authenticateUser: function () {
      this.$store.commit('removeSystem')

      const idSystem = parseInt(this.$route.params.idSystem)
      const endDate = this.$route.params.endDate

      Promise.all([
        fetch(`integrations?cmd=edsystem&id=${idSystem}&user=${this.username}&password=${this.password}&format=json`).then(res => ccHelpers.isSuccess(res) || ccHelpers.handleFailure(res))
      ]).then(data => {
        const systemJson = data[0][0].systems[0]
        this.$store.commit('addSystem',
          new System(
            idSystem, systemJson.name, systemJson.description, systemJson.organisation, systemJson.category, systemJson.sizeUnits, systemJson.size,
            data[0][0].units,
            data[0][0].processes,
            data[0][0].profileschedules
          )
        )

        localStorage.setItem('ccUsername', this.username)
        localStorage.setItem('ccPassword', this.password)
        localStorage.setItem('ccSystem', idSystem)
        localStorage.setItem('ccAuthenticated', true)

        this.$router.push({ name: 'EnergyReport', params: { idSystem: idSystem, endDate: endDate } })
      }).catch(response => {
        this.$refs.ccError.newError('Login failed', ['Are credentials correct and do you have access to the requested HVACR System?', response.message], this.$route.name)
      })
    }
  }
}
</script>
